<template>
  <div id="vessel-insert-data">
    <vessel-form
      mode="insert"
    >
    </vessel-form>
  </div>
</template>

<script>

import VesselForm from "./VesselForm";

export default {
  components: {
    VesselForm,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
